import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation } from "shared/hooks/useApi";
import { DELETE_COMMISSION } from "utils/api/graphql/mutations/commissions";
import { COMMISSIONS } from "utils/api/graphql/queries/commissions";
import { INITIAL_VALUES, SCREENS } from "utils/constants";
import View from "./View";

const Delete = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [visible, setVisible] = useState(true);
  const cancel = () => navigate(SCREENS.PRIVATE.ADMIN.COMMISSIONS.LIST.path);
  const [deleteCommission] = useMutation(DELETE_COMMISSION, {
    refetchQueries: [
      {
        query: COMMISSIONS,
        awaitRefetchQueries: true,
        variables: INITIAL_VALUES,
      },
      {
        query: COMMISSIONS,
        awaitRefetchQueries: true,
      },
    ],
    onCompleted: () => {
      setVisible(false);
      navigate(SCREENS.PRIVATE.ADMIN.COMMISSIONS.LIST.path, { replace: true });
    },
  });
  const onSubmit = () => {
    return deleteCommission({
      variables: {
        where: {
          id,
        },
      },
    });
  };
  return <View onSubmit={onSubmit} cancel={cancel} visible={visible} />;
};

export default Delete;
